import { type DebtorAccess } from "$apis/parkito2/index.ts";
import { DebtorModel } from "./mod.ts";
export default class DebtorAccessModel implements DebtorAccess {
  constructor(private data: DebtorAccess) {
  }

  get debtor(): DebtorModel {
    return new DebtorModel(this.data.debtor);
  }
  get accessLevel() {
    return this.data.accessLevel;
  }
}
